module.exports = __webpack_public_path__ + "img/marker_one_blue1.d160aa83.png";